export default __webpack_public_path__ + "static/1521-6a45fc225d338b65d4bada51ec17c197.gif";